import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { useFormat } from "@sinch/core/hooks/format";
import { isNotNil } from "ramda-adjunct";
import * as React from "react";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { RateTableBody, RateTableFooter, RateTableHead } from "./styledTableComponents";
import { RateComponentsDetail } from "@sinch/components/application/RateComponentsMarginTable/RateComponentsMargin";
import { NotedValue } from "@sinch/views/RateBuilder/RateCalculator/NotedValue";
import { UnitCell } from "@sinch/views/RateBuilder/RateCalculator/UnitCell";

export const DetailsTableContent: FC<{ items: RateComponentsDetail[]; totalTitle: string; total: number }> = ({
  items,
  totalTitle,
  total,
}) => {
  const { num } = useFormat();
  const { t } = useTranslation(["common", "draft"]);

  return (
    <>
      <RateTableHead>
        <TableRow>
          <TableCell>{t("Ratelist.unitName")}</TableCell>
          <TableCell align="right">{t("unit")}</TableCell>
          <TableCell align="right">{t("Ratelist.amountPerUnit")}</TableCell>
          <TableCell align="right">{t("total")}</TableCell>
        </TableRow>
      </RateTableHead>
      {items.length > 0 ? (
        <RateTableBody>
          {items.map((it, ix) => (
            <TableRow key={`${it.ratelistNodeId}-${ix}`}>
              <TableCell sx={{ whiteSpace: "nowrap", maxWidth: 320, overflow: "hidden", textOverflow: "ellipsis" }}>
                {it.rateUnitName}
              </TableCell>
              <TableCell align="right">
                <UnitCell unit={isFinite(Number(it.unit)) ? Number(it.unit) : null} unitName={it.unitName} unroundedUnit={it.unroundedUnit} />
              </TableCell>
              <TableCell align="right">
                <NotedValue
                  note={
                    isNotNil(it.parentRateAmount)
                      ? `${num.precisionCurrency(it.parentRateAmount)} x ${num.percent(it.amount ?? 0)} =`
                      : null
                  }
                >
                  {num.precisionCurrency((it.amount ?? 0) * (it.parentRateAmount ?? 1))}
                </NotedValue>
              </TableCell>
              <TableCell align="right">{num.precisionCurrency(it.total)}</TableCell>
            </TableRow>
          ))}
        </RateTableBody>
      ) : (
        <RateTableBody>
          <TableRow>
            <TableCell colSpan={4}>{t("noEntries")}</TableCell>
          </TableRow>
        </RateTableBody>
      )}
      <RateTableFooter>
        <TableRow>
          <TableCell colSpan={3}>{totalTitle}</TableCell>
          <TableCell align="right">
            <Typography sx={({ typography }) => ({ fontWeight: typography.fontWeightBold })}>
              {num.precisionCurrency(total)}
            </Typography>
          </TableCell>
        </TableRow>
      </RateTableFooter>
    </>
  );
};
